import CameraStream from "./CameraStream";
import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

const ResponsiveGridLayout = WidthProvider(Responsive);

const VideoLayout = ({ cameraFeeds, layoutType, isPlaying, isRTL = false }) => {
  let slice = 0;

  const renderLayouts = () => {
    switch (layoutType) {
      case 1:
        slice = 1;
        return [{ i: "0", x: 0, y: 0, w: 12, h: 12 }];
      case 2:
        slice = 4;
        return Array.from({ length: 4 }, (_, index) => ({
          i: `${index}`,
          x: (index % 2) * 6,
          y: Math.floor(index / 2) * 6,
          w: 6,
          h: 6,
        }));
      case 3:
        slice = 6;
        return [
          { i: "0", x: 0, y: 0, w: 8, h: 8 },
          { i: "1", x: 8, y: 0, w: 4, h: 4 },
          { i: "2", x: 8, y: 4, w: 4, h: 4 },
          { i: "3", x: 0, y: 8, w: 4, h: 4 },
          { i: "4", x: 4, y: 8, w: 4, h: 4 },
          { i: "5", x: 8, y: 8, w: 4, h: 4 },
        ];
      case 4:
        slice = 9;
        return Array.from({ length: 9 }, (_, index) => ({
          i: `${index}`,
          x: (index % 3) * 4,
          y: Math.floor(index / 3) * 4,
          w: 4,
          h: 4,
        }));
      case 5:
        slice = 8;
        return [
          { i: "0", x: 0, y: 0, w: 9, h: 9 },
          { i: "1", x: 9, y: 0, w: 3, h: 3 },
          { i: "2", x: 9, y: 3, w: 3, h: 3 },
          { i: "3", x: 9, y: 6, w: 3, h: 3 },
          { i: "4", x: 0, y: 9, w: 3, h: 3 },
          { i: "5", x: 3, y: 9, w: 3, h: 3 },
          { i: "6", x: 6, y: 9, w: 3, h: 3 },
          { i: "7", x: 9, y: 9, w: 3, h: 3 },
        ];
      default:
        return [];
    }
  };

  const mirrorLayoutForRTL = (layout, totalCols = 12) => {
    return layout.map((item) => ({
      ...item,
      x: totalCols - item.x - item.w,
    }));
  };

  const layout = isRTL ? mirrorLayoutForRTL(renderLayouts()) : renderLayouts();

  return (
    <div dir={isRTL ? "rtl" : "ltr"}>
      <ResponsiveGridLayout
        className="layout"
        layouts={{ lg: layout }}
        breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
        cols={{ lg: 12, md: 12, sm: 12, xs: 4, xxs: 2 }}
        rowHeight={30}
        isDraggable={false}
        isResizable={false}
        measureBeforeMount={false}
        useCSSTransforms={true}
        compactType={null}
        preventCollision={true}
      >
        {layout.map((item, index) => {
          const feed = cameraFeeds[index];

          return (
            <div key={item.i}>
              {feed ? (
                <CameraStream url={feed.hlsUrl} isPlaying={isPlaying} />
              ) : (
                <div
                  className="feed-placeholder"
                  style={{ color: "white", textAlign: "center" }}
                >
                  Please select a channel first
                </div>
              )}
            </div>
          );
        })}
      </ResponsiveGridLayout>
    </div>
  );
};

export default VideoLayout;
